import React from "react"
import { TopButs } from "./TopButs"
import { FormBox } from "./FormBox"
import { TableBox } from "./TableBox"

export const StockEntryDetails = ( props ) => {
    return (
        <>
            <TopButs />
            <FormBox {...props} />
            <TableBox />
        </>
    )
}
